import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async createTeamDecision(_, teamDecision) {
    const response = await axios.post('/blade/team-decisions', teamDecision);
    return response.data.teamDecision;
  },
  async getTeamDecisions() {
    const response = await axios.get('/blade/team-decisions');
    return response.data.teamDecisions;
  },
  async getTeamDecision(_, { teamDecisionId }) {
    const { data } = await axios.get(`/blade/team-decisions/${teamDecisionId}`);
    if (data.teamDecision) {
      if (data.teamDecision.introNarratives == null) {
        data.teamDecision.introNarratives = [];
      }
      if (data.teamDecision.outroNarratives == null) {
        data.teamDecision.outroNarratives = [];
      }
      if (data.teamDecision.decisions != null) {
        for (let d = 0; d < data.teamDecision.decisions.length; ++d) {
          if (data.teamDecision.decisions[d].choices != null) {
            for (let i = 0; i < data.teamDecision.decisions[d].choices.length; ++i) {
              if (data.teamDecision.decisions[d].choices[i].narratives == null) {
                data.teamDecision.decisions[d].choices[i].narratives = [];
              }
            }
          }
        }
      }
    }
    return data;
  },
  async getTeamDecisionTypes({ dispatch }) {
    return dispatch('getTeamDecision', { teamDecisionId: 'types' });
  },
  async updateTeamDecision(_, teamDecision) {
    const response = await axios.patch(`/blade/team-decisions/${teamDecision._id}`, teamDecision);
    return response.data.teamDecision;
  },
  async deleteTeamDecision(_, { teamDecisionId, _id }) {
    const did = teamDecisionId || _id;
    const response = await axios.delete(`/blade/team-decisions/${did}`);
    return response.data.teamDecision;
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/team-decisions.js